export default {
    'en': {
        id: 'Nr.',
        client_id:  'Client ID',
        kunden_nr: 'Client ID',
        firma: 'Company',
        tools: 'CRM-Tool / Phone tool',
        username: 'Email',
        firstname: 'Firstname',
        lastname: 'Lastname',
        status: 'Status',
        email: 'Email',
        phone: 'Phone',
        birthday: 'Birthday',
        company: 'Company',
        address: 'Address',
        client_address: 'Address',
        categories: 'Category',
        categoryName: 'Category',
        actions: 'Action',
        booked_amount: 'Booked',
        invoice_status: '€-Status',
        subject: 'Subject',
        templateAction: 'Usecase',
        coupon_to: 'Coupon receiver',
        coupon_from: 'Coupon sender',
        new_invoice: 'Invoice send',
        booked: 'Booked',
        credit: 'Credit',
        role: 'Role',
        invoice_id: 'Invoice ID',
        invoice_name: 'Receiver',
        invoice_sum: 'Invoice Sum',
        invoice_date: 'Invoice Date',
        invoice_event: 'Invoice Event',
        clientsOfCategory: 'Active Clients',
        event_start: 'Event time',
        event_time: 'Event date',
        event_amount_by_user: 'Booked',
        event_price: 'Price',
        event_name: 'Event name',
        event_subname: 'Event Subname',
        invoice_client_name: 'Receiver',
        from_name: 'Sender name',
        to_name: 'Receicer name',
        from_email: 'Sender Email',
        to_email: 'Receiver Email',
        coupon_price: 'Amount',
        coupon_status: '€-Status',
        credit_id: 'Credit ID',
        credit_date: 'Credit date',
        credit_name: 'Receiver name',
        credit_sum: 'Credit amount',
        credit_done: 'Event',
        credit_invoice_id: 'Invoice',
        credit_credit_invoice_id: 'Invoice',
        credit_status: 'Status',
        active_events_by_cat:'Active events',
        role_name: 'Role',
        templateActionName: 'Action',
        invoice_reminder: 'Invoice reminder',
        invoice_warning: 'Invoice warning',
        cancel_client: 'Cancel client from event',
        rebook_client: 'Rebbok client',
        update_client: 'Update Clients booking',
        coupon_code: 'Coupon code',
        template_action_name: 'Template Action',
        invoice_prefix: 'Invoice Prefix',
        credit_prefix: 'Credit Prefix',
        booked_guests: 'Guests',
        bookings: 'Buchungen',
        guests: 'Guests',
        payment_asap: '',
        payment_14: '',
        payment_custom: '',
        agency: 'Agency',
        nezasa_id: 'Nezasa ID',
        offer_id: 'Offer ID.',
        client_name: 'Client',
        sales_name: 'Sales',
        booking_state: 'Status',
        trip_date: 'Trip date',
        supplier_name: 'Supplier name',
        coordinate:'Coordinates',
        state:'State',
        count: "trips created",
        countUser: "visited by end customers",
        countMailSent: "login emails sent",
        brandingName: "Branding",
        trip_id: 'Trip ID',
        link: 'Active Url',
        supersuper: 'Super Admin',
        trips_isolated: 'Only Own Trips',
        totp_enabled: '2FA',
        checkout_url: 'Checkout URL',
        branding_name: 'Branding',
        updated_by: 'Updated By',
        updated_at: 'Updated At',
    },
    'de': {
        id: 'Nr.',
        client_id:  'Kd.Nr.',
        kunden_nr: 'KD.Nr.',
        firma: 'Firma',
        tools: 'CRM-Tool / Telefontool',
        username: 'E-Mail',
        firstname: 'Vorname',
        lastname: 'Nachname',
        status: 'Status',
        email: 'E-mail',
        phone: 'Telefon',
        birthday: 'Geburtstag',
        company: 'Firma',
        address: 'Adresse',
        client_address: 'Adresse',
        categories: 'Kategorie',
        categoryName: 'Kategorie',
        actions: 'Aktion',
        booked_amount: 'Plätze',
        invoice_status: '€-Status',
        subject: 'Betreff',
        templateAction: 'Einsatzzweck',
        coupon_to: 'Gutschein Empfänger',
        coupon_from: 'Gutschein Absender',
        new_invoice: 'Rechnung versendet',
        booked: 'Veranstaltung gebucht',
        credit: 'Gutschrift',
        role: 'Rolle',
        invoice_id: 'Rg.Nr.',
        invoice_name: 'Rg.Empfänger',
        invoice_sum: 'Rg.Betrag',
        invoice_date: 'Rg.Datum',
        invoice_event: 'Leistung',
        clientsOfCategory: 'Aktive Kunden',
        event_start: 'Veranstaltungsdatum',
        event_time: 'Veranstaltungszeit',
        event_amount_by_user: 'Anzahl Personen',
        event_price: 'Preis p.P.',
        event_name: 'Veranstaltungsname',
        event_subname: 'Untertitel',
        invoice_client_name: 'Empfänger',
        from_name: 'Ausst. Name',
        to_name: 'Empf. Name',
        from_email: 'Ausst. Email',
        to_email: 'Empf. Email',
        coupon_price: 'Wert',
        coupon_status: '€-Status',
        credit_id: 'Nr.',
        credit_date: 'Gutschr.Datum',
        credit_name: 'Gutschr.Empf.',
        credit_sum: 'Gutschr.',
        credit_done: 'Leistung/ VA',
        credit_invoice_id: 'Zugew. Rg.',
        credit_credit_invoice_id: 'Zugew. Rg.',
        credit_status: 'Status',
        active_events_by_cat: 'Aktive Veranstaltungen',
        role_name: 'Benutzerrolle',
        templateActionName: 'Aktion',
        invoice_reminder: 'Rechnungserinnerung',
        invoice_warning: 'Mahnung',
        cancel_client: 'Stornierung eines Teilnehmers',
        rebook_client: 'Umbuchung',
        update_client: 'Teilnehmeraktualisierung',
        coupon_code: 'Gutschein-Code',
        template_action_name: 'Template Aktion',
        invoice_prefix: 'Rechnung-Prefix',
        credit_prefix: 'Gutschrift-Prefix',
        booked_guests: 'Gäste',
        bookings: 'Buchungen',
        guests: 'Gäste',
        payment_asap: 'Zahlungsziel: sofort',
        payment_14: 'Zuahlungsziel: 14 Tage',
        payment_custom: 'Zahlungsziel: individuell',
        agency: 'Reisebüro',
        nezasa_id: 'Nezasa ID',
        offer_id: 'Ang-Nr.',
        client_name: 'Kunde',
        sales_name: 'Verkäufer',
        booking_state: 'Status',
        count: "Anzahl erstellter Trip",
        countUser: "davon vom Endkunden besucht",
        countMailSent: "Login-E-Mails gesendet",
        brandingName: "Branding",
        trip_date: 'Reisezeitraum',
        supplier_name: 'Supplier Name',
        coordinate:'Koordinaten',
        state:'Bundesland',
        trip_id: 'Reise-ID',
        link: 'Aktive URL',
        supersuper: 'Super Admin',
        trips_isolated: 'Nur Eigene Reizen',
        totp_enabled: '2FA Aktiv',
    },
    'fr': {
        id: 'N°',
        client_id: 'ID client',
        kunden_nr: 'ID client',
        firma: 'Entreprise',
        tools: 'Outil CRM / Téléphone',
        username: 'Email',
        firstname: 'Prénom',
        lastname: 'Nom',
        status: 'Statut',
        email: 'Email',
        phone: 'Téléphone',
        birthday: 'Date de naissance',
        company: 'Entreprise',
        address: 'Adresse',
        client_address: 'Adresse',
        categories: 'Catégorie',
        categoryName: 'Catégorie',
        actions: 'Action',
        booked_amount: 'Réservé',
        invoice_status: 'Statut €',
        subject: 'Sujet',
        templateAction: 'Cas d\'utilisation',
        coupon_to: 'Destinataire du bon',
        coupon_from: 'Expéditeur du bon',
        new_invoice: 'Facture envoyée',
        booked: 'Réservé',
        credit: 'Crédit',
        role: 'Rôle',
        invoice_id: 'ID facture',
        invoice_name: 'Destinataire',
        invoice_sum: 'Montant facture',
        invoice_date: 'Date facture',
        invoice_event: 'Événement facture',
        clientsOfCategory: 'Clients actifs',
        event_start: 'Heure de l\'événement',
        event_time: 'Date de l\'événement',
        event_amount_by_user: 'Réservé',
        event_price: 'Prix',
        event_name: 'Nom de l\'événement',
        event_subname: 'Sous-nom de l\'événement',
        invoice_client_name: 'Destinataire',
        from_name: 'Nom de l\'expéditeur',
        to_name: 'Nom du destinataire',
        from_email: 'Email de l\'expéditeur',
        to_email: 'Email du destinataire',
        coupon_price: 'Montant',
        coupon_status: 'Statut €',
        credit_id: 'ID crédit',
        credit_date: 'Date crédit',
        credit_name: 'Nom du destinataire',
        credit_sum: 'Montant crédit',
        credit_done: 'Événement',
        credit_invoice_id: 'Facture',
        credit_credit_invoice_id: 'Facture',
        credit_status: 'Statut',
        active_events_by_cat: 'Événements actifs',
        role_name: 'Rôle',
        templateActionName: 'Action',
        invoice_reminder: 'Rappel facture',
        invoice_warning: 'Alerte facture',
        cancel_client: 'Annuler le client de l\'événement',
        rebook_client: 'Reprogrammer le client',
        update_client: 'Mettre à jour la réservation',
        coupon_code: 'Code du bon',
        template_action_name: 'Action du modèle',
        invoice_prefix: 'Préfixe facture',
        credit_prefix: 'Préfixe crédit',
        booked_guests: 'Invités',
        bookings: 'Réservations',
        guests: 'Invités',
        payment_asap: '',
        payment_14: '',
        payment_custom: '',
        agency: 'Agence',
        nezasa_id: 'ID Nezasa',
        offer_id: 'ID de l\'offre',
        client_name: 'Client',
        sales_name: 'Commercial',
        booking_state: 'Statut',
        trip_date: 'Date du voyage',
        supplier_name: 'Nom fournisseur',
        coordinate: 'Coordonnées',
        state: 'État',
        count: 'Voyages créés',
        countUser: 'Consulté par les clients finaux',
        countMailSent: "e-mails de connexion envoyés",
        brandingName: 'Identité visuelle',
        trip_id: 'ID du voyage',
        link: 'URL active',
        supersuper: 'Super Admin',
        trips_isolated: 'Uniquement voyages utilisateur',
        totp_enabled: '2FA Actif',
    },
    'nl': {
        id: 'Nr.',
        client_id: 'Klant-ID',
        kunden_nr: 'Klant-ID',
        firma: 'Bedrijf',
        tools: 'CRM-tool / Telefoontool',
        username: 'E-mail',
        firstname: 'Voornaam',
        lastname: 'Achternaam',
        status: 'Status',
        email: 'E-mail',
        phone: 'Telefoon',
        birthday: 'Geboortedatum',
        company: 'Bedrijf',
        address: 'Adres',
        client_address: 'Adres',
        categories: 'Categorie',
        categoryName: 'Categorie',
        actions: 'Actie',
        booked_amount: 'Geboekt',
        invoice_status: '€-Status',
        subject: 'Onderwerp',
        templateAction: 'Gebruikssituatie',
        coupon_to: 'Bon ontvanger',
        coupon_from: 'Bon verzender',
        new_invoice: 'Factuur verzonden',
        booked: 'Geboekt',
        credit: 'Krediet',
        role: 'Rol',
        invoice_id: 'Factuur-ID',
        invoice_name: 'Ontvanger',
        invoice_sum: 'Factuurbedrag',
        invoice_date: 'Factuurdatum',
        invoice_event: 'Factuurevenement',
        clientsOfCategory: 'Actieve klanten',
        event_start: 'Tijd evenement',
        event_time: 'Datum evenement',
        event_amount_by_user: 'Geboekt',
        event_price: 'Prijs',
        event_name: 'Evenementnaam',
        event_subname: 'Subnaam evenement',
        invoice_client_name: 'Ontvanger',
        from_name: 'Naam afzender',
        to_name: 'Naam ontvanger',
        from_email: 'E-mail afzender',
        to_email: 'E-mail ontvanger',
        coupon_price: 'Bedrag',
        coupon_status: '€-Status',
        credit_id: 'Krediet-ID',
        credit_date: 'Kredietdatum',
        credit_name: 'Naam ontvanger',
        credit_sum: 'Kredietbedrag',
        credit_done: 'Evenement',
        credit_invoice_id: 'Factuur',
        credit_credit_invoice_id: 'Factuur',
        credit_status: 'Status',
        active_events_by_cat: 'Actieve evenementen',
        role_name: 'Rol',
        templateActionName: 'Actie',
        invoice_reminder: 'Factuurherinnering',
        invoice_warning: 'Factuurwaarschuwing',
        cancel_client: 'Klant annuleren van evenement',
        rebook_client: 'Klant opnieuw boeken',
        update_client: 'Boeking bijwerken',
        coupon_code: 'Kortingscode',
        template_action_name: 'Sjabloonactie',
        invoice_prefix: 'Factuurvoorvoegsel',
        credit_prefix: 'Kredietvoorvoegsel',
        booked_guests: 'Gasten',
        bookings: 'Boekingen',
        guests: 'Gasten',
        payment_asap: '',
        payment_14: '',
        payment_custom: '',
        agency: 'Agentschap',
        nezasa_id: 'Nezasa-ID',
        offer_id: 'Aanbiedings-ID',
        client_name: 'Klant',
        sales_name: 'Verkoop',
        booking_state: 'Status',
        trip_date: 'Reisdatum',
        supplier_name: 'Leveranciersnaam',
        coordinate: 'Coördinaten',
        state: 'Provincie',
        count: 'Gemaakte reizen',
        countUser: 'Bekeken door eindklanten',
        countMailSent: "login e-mails verzonden",
        brandingName: 'Branding',
        trip_id: 'Reis-ID',
        link: 'Actieve URL',
        supersuper: 'Super Admin',
        trips_isolated: 'Alleen gebruikersreizen',
        totp_enabled: '2FA Actief',
    },
    'el': {
        "id": "Αρ.",
        "client_id": "Αναγνωριστικό πελάτη",
        "kunden_nr": "Αναγνωριστικό πελάτη",
        "firma": "Εταιρεία",
        "tools": "Εργαλείο CRM / Τηλεφωνικό εργαλείο",
        "username": "Email",
        "firstname": "Όνομα",
        "lastname": "Επώνυμο",
        "status": "Κατάσταση",
        "email": "Email",
        "phone": "Τηλέφωνο",
        "birthday": "Γενέθλια",
        "company": "Εταιρεία",
        "address": "Διεύθυνση",
        "client_address": "Διεύθυνση",
        "categories": "Κατηγορία",
        "categoryName": "Κατηγορία",
        "actions": "Ενέργεια",
        "booked_amount": "Κρατήσεις",
        "invoice_status": "Κατάσταση €",
        "subject": "Θέμα",
        "templateAction": "Περίπτωση χρήσης",
        "coupon_to": "Παραλήπτης κουπονιού",
        "coupon_from": "Αποστολέας κουπονιού",
        "new_invoice": "Αποστολή τιμολογίου",
        "booked": "Κρατήσεις",
        "credit": "Πίστωση",
        "role": "Ρόλος",
        "invoice_id": "Αναγνωριστικό τιμολογίου",
        "invoice_name": "Παραλήπτης",
        "invoice_sum": "Ποσό τιμολογίου",
        "invoice_date": "Ημερομηνία τιμολογίου",
        "invoice_event": "Γεγονός τιμολογίου",
        "clientsOfCategory": "Ενεργοί πελάτες",
        "event_start": "Ώρα εκδήλωσης",
        "event_time": "Ημερομηνία εκδήλωσης",
        "event_amount_by_user": "Κρατημένα",
        "event_price": "Τιμή",
        "event_name": "Όνομα εκδήλωσης",
        "event_subname": "Υπότιτλος εκδήλωσης",
        "invoice_client_name": "Παραλήπτης",
        "from_name": "Όνομα αποστολέα",
        "to_name": "Όνομα παραλήπτη",
        "from_email": "Email αποστολέα",
        "to_email": "Email παραλήπτη",
        "coupon_price": "Ποσό",
        "coupon_status": "Κατάσταση €",
        "credit_id": "Αναγνωριστικό πίστωσης",
        "credit_date": "Ημερομηνία πίστωσης",
        "credit_name": "Παραλήπτης",
        "credit_sum": "Ποσό πίστωσης",
        "credit_done": "Γεγονός",
        "credit_invoice_id": "Τιμολόγιο",
        "credit_credit_invoice_id": "Τιμολόγιο",
        "credit_status": "Κατάσταση",
        "active_events_by_cat": "Ενεργές εκδηλώσεις",
        "role_name": "Ρόλος",
        "templateActionName": "Ενέργεια",
        "invoice_reminder": "Υπενθύμιση τιμολογίου",
        "invoice_warning": "Προειδοποίηση τιμολογίου",
        "cancel_client": "Ακύρωση πελάτη από εκδήλωση",
        "rebook_client": "Επανακράτηση πελάτη",
        "update_client": "Ενημέρωση κράτησης πελάτη",
        "coupon_code": "Κωδικός κουπονιού",
        "template_action_name": "Ενέργεια προτύπου",
        "invoice_prefix": "Πρόθεμα τιμολογίου",
        "credit_prefix": "Πρόθεμα πίστωσης",
        "booked_guests": "Επισκέπτες",
        "bookings": "Κρατήσεις",
        "guests": "Επισκέπτες",
        "payment_asap": "",
        "payment_14": "",
        "payment_custom": "",
        "agency": "Πρακτορείο",
        "nezasa_id": "Αναγνωριστικό Nezasa",
        "offer_id": "Αναγνωριστικό προσφοράς",
        "client_name": "Πελάτης",
        "sales_name": "Πωλήσεις",
        "booking_state": "Κατάσταση",
        "trip_date": "Ημερομηνία ταξιδιού",
        "supplier_name": "Όνομα προμηθευτή",
        "coordinate": "Συντεταγμένες",
        "state": "Πολιτεία",
        "count": "Δημιουργημένα ταξίδια",
        "countUser": "Επισκέφθηκε από τελικούς πελάτες",
        "countMailSent": "email σύνδεσης εστάλη",
        "brandingName": "Branding",
        "trip_id": 'Κωδικός Ταξιδιού',
        "link": 'Ενεργό URL',
        supersuper: 'Super Admin',
        trips_isolated: 'Μόνο ταξίδια χρήστη',
        totp_enabled: '2FA Ενεργό',
    }
}